import { LitElement, html } from "lit";

import sharedStyles from "../../styles/shared.js";
import tableStyles from "../../styles/tables.js";

export default class SignView extends LitElement {
	render() {
		return html`
    ${sharedStyles}
    ${tableStyles}
      <header class="horizontal-menu-header">
      <router-link to="/sign/documents">
          <a>Documents</a>
        </router-link>
        <router-link to="/sign/orders">
          <a>Sign Requests</a>
        </router-link>
      </header>
      <slot></slot>
    `;
	}
}

customElements.define("sign-view", SignView);
